import { TFunction } from "i18next";

import { IconChevronDown, IconMail03 } from "@pentabd/icons";
import { Select, Text } from "@pentabd/ui";

import { updateAttendance } from "@api/attendance";
import { ProfileInfoCard } from "@components";
import { MASTER_DATA } from "@constants/master-data";
import { getConvertedMasterData } from "@helpers/masterDataConvert";
import { useLanguage } from "@hooks/useLanguage";
import { useMasterData } from "@hooks/useMasterData";
import { convertToAM_PM } from "@utils/amToPm";
import { timeDuration } from "@utils/duration";

const { ATTENDANCE_STATUS } = MASTER_DATA;

export const AttendanceTableColumn = (
  t: TFunction<"translation", undefined>,
  selectedDate: string,
  openMailModal: () => void,
) => {
  const { data: attendanceStatus } = useMasterData(ATTENDANCE_STATUS);
  const { language } = useLanguage();
  // !!!!!
  return [
    {
      id: 0,
      key: "employee",
      name: t("ATTENDANCE.TABLE.COLUMN.NAME"),
      render: (data: any, row: any) => <ProfileInfoCard employee={row} />,
    },
    {
      id: 1,
      key: "employeeID",
      name: t("ATTENDANCE.TABLE.COLUMN.EMPLOYEE_ID"),
      render: (employeeID: number) => <Text color="info">{employeeID}</Text>,
    },
    {
      id: 2,
      key: "positionName",
      name: t("ATTENDANCE.TABLE.COLUMN.POSITION"),
      render: (positionName: any) => (
        <Text color="subtitle1">{positionName}</Text>
      ),
    },
    {
      id: 3,
      key: "firstIn",
      name: t("ATTENDANCE.TABLE.COLUMN.FIRST_IN"),
      render: (firstIn: string) => (
        <Text color="subtitle1">{convertToAM_PM(firstIn)}</Text>
      ),
    },
    {
      id: 4,
      key: "lastOut",
      name: t("ATTENDANCE.TABLE.COLUMN.LAST_OUT"),
      render: (lastOut: string) => (
        <Text color="subtitle1">{convertToAM_PM(lastOut)}</Text>
      ),
    },
    {
      id: 5,
      key: "total",
      name: t("ATTENDANCE.TABLE.COLUMN.TOTAL"),
      render: (total: string, row: any) => (
        <Text color="subtitle1">
          {timeDuration(row?.firstIn, row?.lastOut)}
        </Text>
      ),
    },
    {
      id: 6,
      key: "statusId",
      name: t("ATTENDANCE.TABLE.COLUMN.STATUS"),
      render: (data: number, row: any) => {
        const { employeeID, attendanceID, firstIn, lastOut, statusId } = row;

        return (
          <Select
            portal
            name="status"
            size="xs"
            options={getConvertedMasterData(attendanceStatus, language)}
            defaultValue={statusId}
            onSelectItem={(e) =>
              updateAttendance({
                attendanceId: attendanceID,
                data: {
                  employeeId: employeeID,
                  attendanceDate: selectedDate,
                  firstIn,
                  lastOut,
                  statusId: e,
                },
              })
            }
            placeholder={t("ATTENDANCE.TABLE.COLUMN.SELECT")}
            suffix={<IconChevronDown size="16" />}
          />
        );
      },
    },
    {
      id: 7,
      key: "id",
      name: "",
      render: (id: number) => {
        return (
          <div
            onClick={() => {
              openMailModal();
            }}
            className="cursor-pointer"
          >
            <IconMail03 fill="primary" size={24} />
          </div>
        );
      },
    },
  ];
};
